import { FAQ, FaqApiResponse, FaqQuestionItem } from '@/interfaces/faq';
import { TFunction } from 'i18next';

const getCategoryTranslation = (category: string, t: TFunction<'translation', undefined>): string => {
  const translationKey = `faqCategories.${category}`;
  const translation = t(translationKey);

  if (translation === translationKey) {
    return category
      .split('_')
      .map(word => word.charAt(0) + word.slice(1).toLowerCase())
      .join(' ');
  }

  return translation;
};

export const formatFaqResponse = (apiResponse: FaqApiResponse, currentLanguage: string, t: TFunction<'translation', undefined>): FAQ[] => {
  const languageCode = currentLanguage.toUpperCase();

  const categoriesMap = new Map<string, FaqQuestionItem[]>();

  apiResponse.questions.forEach(question => {
    if (!categoriesMap.has(question.category)) {
      categoriesMap.set(question.category, []);
    }
    categoriesMap.get(question.category)!.push(question);
  });

  const faqs: FAQ[] = [];

  categoriesMap.forEach((questions, category) => {
    const categoryKey = category.toLowerCase().replace(/_/g, '');
    const categoryTitle = getCategoryTranslation(category, t);

    const subcategoryQuestions = questions.map(q => {
      const translation = q.translations.find(t => t.language === languageCode) || q.translations[0];

      return {
        title: translation?.question || '',
        body: translation?.answer || '',
      };
    });

    faqs.push({
      key: categoryKey,
      title: categoryTitle,
      questions: [
        {
          key: categoryKey,
          header: categoryTitle,
          body: subcategoryQuestions,
        },
      ],
    });
  });

  return faqs;
};
